import { render, staticRenderFns } from "./TemplateCustomisationActionButtons.vue?vue&type=template&id=f840db5e&"
import script from "./TemplateCustomisationActionButtons.vue?vue&type=script&lang=ts&"
export * from "./TemplateCustomisationActionButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
